/*
 * File: form-string.ts
 * File Created: 2024-01-11 01:28:50
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-26 01:30:16
 * Modified By: Val Liu
 * -----
 */

import { Component } from "vue-property-decorator";
import { BaseFormComponent } from "../../core/lib/base-form-component";
import {
    IFormComponentAttr,
    IFormValidateResult,
    createRequiredValidator,
} from "../../core/lib/core";
import { PropInnateSync } from "@root/core/vue-props";
import { UITag } from "@root/core/tags";
import { makeRequiredValidator } from "@root/core/decorators/make-validator";

@Component
@UITag.setDefault({
    uiBlockAutofill: true,
})
export default class FormMonth extends BaseFormComponent {
    @PropInnateSync("value", { type: Date, required: false })
    innateValue!: Date | undefined;

    /// private helpers
    // required validation for month
    @makeRequiredValidator({
        validator: (o) => !(o.value == null),
    })
    defaultRequired() {
        return undefined;
    }
}
